module.exports = __webpack_public_path__ + "6c730a166dc4386e27578a4487cfb157.svg";